<template>
  <div class="box cake p-3" style="background: white">
    <K2Row space-between="true" align="center">
      <K2Image :src="assets.image.macControl" />
      <K2Row>
        <!-- <K2Text textAlign="center" className="me-2 d-block">{{ this.title }}</K2Text>
        <a @click="handleParentEdit()">
          <K2Image :src="assets.icon.edit" :height="20"/>
        </a> -->
      </K2Row>
      <K2Row>
        <K2Button size="medium" type="danger" class="me-2" @onclick="handleParentEmpty()">Clear</K2Button>
        <K2Button size="medium" :background="uiVariable.color.button1" color="white" @onclick="handleParentPost()">
          <K2Text color="white">POST</K2Text>
        </K2Button>
      </K2Row>
    </K2Row>
  </div>
</template>

<script>
import K2Row from '../../../uiComponents/k2Row/k2Row'
import K2Image from '../../../uiComponents/k2Image/k2Image'
import K2Text from '../../../uiComponents/k2Text/k2Text'
import K2Button from '../../../uiComponents/k2Button/k2Button'
import uiVariable from '../../../config/uiVariable'
import assets from '../../../assets/assets'

export default {
  name: 'EmailHeader',
  props: ['handleEdit', 'handleEmpty', 'handlePost', 'title'],
  components: {
    K2Button,
    K2Text,
    K2Image,
    K2Row,
  },
  data() {
    return {
      uiVariable: uiVariable,
      assets: assets,
    }
  },
  methods: {
    handleParentEmpty() {
      this.$emit('handleEmpty')
    },
    handleParentEdit() {
      this.$emit('handleEdit')
    },
    handleParentPost() {
      this.$emit('handlePost')
    },
  },
}
</script>
